class ApiState {
    public isInitialCallCompleted = false;

    public initialCallPromiseResolver: null | (() => void) = null;

    public initialCallCompletedPromise = new Promise<void>(resolve => {
        this.initialCallPromiseResolver = resolve;
    });
}

const apiState = new ApiState();

export { apiState };
